var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoAndroid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "logo-android_svg__st0",
    d: "M34.5 13c-1.4 0-2.5 1.1-2.5 2.5v10.3c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5V15.5c0-1.4-1.1-2.5-2.5-2.5zM5.7 13c-1.4 0-2.5 1.1-2.5 2.5v10.3c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5V15.5C8.1 14.1 7 13 5.7 13zm25.4.4v16c0 1.5-1.2 2.7-2.7 2.7h-1.8v5.5c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-5.5h-3.3v5.5c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-5.5h-1.8c-1.5 0-2.7-1.2-2.7-2.7v-16h22.3zm-5.6-9.7L27.2.5c.1-.2 0-.4-.1-.5h-.2c-.1 0-.2.1-.3.2l-1.8 3.2c-1.4-.6-3.1-1-4.8-1-1.7 0-3.3.4-4.8 1L13.4.2c.1-.2-.1-.3-.3-.2s-.2.3-.1.5l1.7 3.2c-3.4 1.7-5.6 5.1-5.6 8.9h22.1c-.1-3.9-2.3-7.2-5.7-8.9zM15 8.5c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9-.4.9-.9.9zm10.2 0c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9-.4.9-.9.9z"
  })));
}

export default SvgLogoAndroid;